module.exports = __webpack_public_path__ + "static/media/4ODA13.488c6559.jpg";